// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import React, { useEffect } from "react";
import { app, authentication } from "@microsoft/teams-js";


const SignInSimpleEnd: React.FunctionComponent = () => {
    // Parse hash parameters into key-value pairs
    function getHashParameters() {
        const hashParams: Map<string, string> = new Map<string, string>();
        window.location.hash.substr(1).split("&").forEach(function (item) {
            let s = item.split("="),
                k = s[0],
                v = s[1] && decodeURIComponent(s[1]);
            hashParams.set(k, v);
        });
        return hashParams;
    }

    useEffect(() => {

        const init = async () => {
            if (!app.isInitialized()) {
                await app.initialize();
            }

            const hashParams: Map<string, string> = getHashParameters();
            if (hashParams.has("error")) {
                // Authentication/authorization failed
                authentication.notifyFailure(hashParams.get("error"));
            } else if (hashParams.has("id_token")) {
                // Success
                authentication.notifySuccess(hashParams.get("state"));
            } else {
                // Unexpected condition: hash does not contain error or access_token parameter
                authentication.notifyFailure("UnexpectedFailure");
            }
        }

        init().catch(console.error);
    }, []);

    return (
        <></>
    );
};

export default SignInSimpleEnd;